import { ReactNode } from 'react';

import { RiAddLine } from '@remixicon/react';

import { Button } from '@spotify-internal/encore-web';

export type PageContentActionBarCreateButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  'data-testid'?: string;
  children?: ReactNode;
};

export const ContentActionBarCreateButton = ({
  onClick,
  disabled,
  children = 'Create',
  ...rest
}: PageContentActionBarCreateButtonProps) => (
  <Button variant="primary" onClick={onClick} disabled={disabled} {...rest}>
    <RiAddLine />
    {children}
  </Button>
);
